import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';

import { ConfigService, MessageService } from '../../../core';
import { isModoPadrao, isModoTabelaPreco, orcamento } from '../../configuracoes/app/pedido';
import { pedidoNaoConfirmado } from '../status';

@Injectable({
    providedIn: 'root'
})
export class PedidoRouterService {
    constructor(private router: Router,
                private configService: ConfigService,
                private messageService: MessageService) { }

    /** Obtem o path correto conforme o modo do Pedido */
    private getPathByModo(modo: number): string {
        // Padrão
        if (isModoPadrao(modo)) {
            return 'pd';
        }
        // Tabela de Preço
        if (isModoTabelaPreco(modo)) {
            return 'tp';
        }

        return '';
    }

    /**
     * Realiza o insert e redereciona para o form do pedido
     *
     * @param activatedRoute
     * @param tipoVenda tipo de venda do pedido a ser inserido
     * @param status status do pedido a ser inserido
     * @param idCliente ID do cliente do pedido a ser inserido
     */
    insert(activatedRoute: ActivatedRoute, tipoVenda: number = null, status: number = null, idCliente: number = null, idPessoa: number = null, idNegocio: number = null, possuiCampanha: boolean = null, idCampanha: number = null) {
        // Modo
        const path = this.getPathByModo(this.configService.getPedido().modo);
        // Query Params
        const queryParams: Params = [];
        queryParams['tipoVenda'] = tipoVenda ?? null;
        queryParams['status'] = status ?? null;
        queryParams['cliente'] = idCliente ?? null;
        queryParams['idPessoa'] = idPessoa ?? null;

        // Negócio
        queryParams['idNegocio'] = idNegocio ?? null;
        if (idNegocio) {
            queryParams['returnToNegocio'] = 'true';
        }

        // Campanha
        if (possuiCampanha != null && possuiCampanha !== undefined) {
            queryParams['possuiCampanha'] = possuiCampanha.toString();
        }
        queryParams['idCampanha'] = idCampanha ?? null;

        this.router.navigate(['/pedidos', path, 'novo'], {relativeTo:  activatedRoute, queryParams});
    }

    /**
     * Realiza o edit e redereciona para o form do pedido
     */
    edit(id: number, activatedRoute: ActivatedRoute) {
        const path = this.getPathByModo(this.configService.getPedido().modo);
        this.router.navigate(['/pedidos', path, id], {relativeTo:  activatedRoute});
    }

    /**
     * Realiza o duplicate e redereciona para o form do pedido
     */
    duplicate(id: number, numero: number, activatedRoute: ActivatedRoute) {
        this.messageService.confirm(`Deseja realmente duplicar o pedido ${numero ? numero : ''}?`, 'Confirme').then(result => {
            if (result) {
                const path = this.getPathByModo(this.configService.getPedido().modo);
                this.router.navigate(['/pedidos', path, id, 'duplicar'], {relativeTo:  activatedRoute});
            }
        });
    }

    openRetornoAmostras(id: number, activatedRoute: ActivatedRoute) {
        this.router.navigate(['/pedidos', 'retorno-amostra', id], {relativeTo:  activatedRoute});
    }

    /**
     * Realiza redereciona para o form do pedido quando for para somente ler/consultar o registro
     */
    read(id: number, activatedRoute: ActivatedRoute) {
        const path = this.getPathByModo(this.configService.getPedido().modo);
        this.router.navigate(['/pedidos', path, id], {relativeTo:  activatedRoute});
    }

    /** Navega para a rota informada */
    navigate(pathRoutes: any[], queryParams: Params, activatedRoute: ActivatedRoute) {
        const path = this.getPathByModo(this.configService.getPedido().modo);
        this.router.navigate(['/pedidos', path, ...pathRoutes], {relativeTo: activatedRoute, queryParams});
    }

    /** Navega para o form do retorno da análise do cliente */
    openRetornoAnaliseCLiente(id: number, itensGanhos: boolean, activatedRoute: ActivatedRoute) {
        // Query Params
        const queryParams: Params = [];
        queryParams['itensGanhos'] = itensGanhos != null && itensGanhos !== undefined ? itensGanhos.toString() : null;

        this.router.navigate(['/pedidos', 'retorno-analise-cliente', id], {relativeTo:  activatedRoute, queryParams});
    }

    /**
     * Insere um novo orçamento/pedido através de um negócio
     */
    insertByNegocio(activatedRoute: ActivatedRoute, idCliente: number, idNegocio: number, idCampanha: number) {
        this.insert(activatedRoute, orcamento.id, null, idCliente, null, idNegocio, idCampanha > 0, idCampanha);
    }

    /**
     * Abre um pedido através de um negócio
     */
    openFromNegocio(activatedRoute: ActivatedRoute, id: number) {
        // Modo
        const path = this.getPathByModo(this.configService.getPedido().modo);
        // Query Params
        const queryParams: Params = [];
        queryParams['returnToNegocio'] = 'true';

        this.router.navigate(['/pedidos', path, id], {relativeTo:  activatedRoute, queryParams});
    }

    /**
     * Abre um pedido através da Cotação
     */
    openFromCotacao(id: number) {
        const path = this.getPathByModo(this.configService.getPedido().modo);
        this.router.navigate(['pedidos', path, id]);
    }

    /**
     * Abre um pedido através da Nota Fiscal
     */
    openFromNotaFiscal(id: number) {
        const path = this.getPathByModo(this.configService.getPedido().modo);
        this.router.navigate(['pedidos', path, id]);
    }
}
